'use client'

import Image from 'next/image';
import Link from 'next/link';
import { useState, useEffect } from 'react'
import {
  CTAButton,
  CTAGroup
} from '@/components/ui'
import { APP_LOGIN_URL } from '@/lib/redirect-utils';
import { BUTTON_IDS } from '@/lib/constants';
import dynamic from 'next/dynamic';
import { usePageSettings } from '@/components/contexts/PageSettingsContext';
const UTMCookieHandler = dynamic(() => import('@/components/analytics/StoreUTM'))



const RodrigoHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { enableHeaderGoogleLogin, showGoogleLogoHeader, showHeaderCTAs: showCTAs=true } = usePageSettings()

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <UTMCookieHandler />
      <header
        className={
          `header-main-container border-1  mb-5 sticky top-5 z-[9999] w-[90vw] sm:w-[85vw] md:w-[95vw] mx-auto shadow-lg bg-black
        ${mobileMenuOpen ? 'rounded-t-xl' : 'rounded-xl'}
        ${isScrolled ? 'border-brand-border  transition-colors duration-300' : 'border-transparent'}`
        }
      >
        <div className="header-container flex justify-between items-center px-3 sm:px-8 sm:h-16 h-14 w-full">
          {/* Logo */}
          <div className="logo-container flex items-center relative">
            <Link href="#" className="logo flex items-center font-bold text-base text-white no-underline">
              <Image
                className=' sm:h-7 min-h-3 max-h-6 w-full object-contain '
                height={200}
                width={200}
                src="/hypertask_white.png"
                alt="HYPERTASK.AI Logo"
                loading="lazy"
              />
            </Link>
          </div>

          {
            showCTAs &&
              <>
                {/* Desktop Auth Buttons - 20px gap */}
                <div className="desktop-auth hidden md:block">
                  <CTAGroup >
                    <CTAButton
                      usedInHeader={true}
                      id='login-button'
                      href={APP_LOGIN_URL}
                      variant="secondary"
                      size="header"
                      enableGoogleLogin={enableHeaderGoogleLogin}
                      showGoogleLogo={false}
                    >
                      Login
                    </CTAButton>
                    <CTAButton
                      usedInHeader={true}
                      id={BUTTON_IDS.GET_STARTED}
                      href={APP_LOGIN_URL}
                      variant="primary"
                      size="header"
                      enableGoogleLogin={enableHeaderGoogleLogin}
                      showGoogleLogo={showGoogleLogoHeader}
                    >
                      Get Started
                    </CTAButton>
                  </CTAGroup>
                </div>

                {/* Mobile CTA + Menu Button */}
                <div className="md:hidden flex items-center gap-2">
                  <CTAButton
                    usedInHeader={true}
                    id={BUTTON_IDS.GET_STARTED}
                    href={APP_LOGIN_URL}
                    variant="primary"
                    size="header"
                    enableGoogleLogin={enableHeaderGoogleLogin}
                    showGoogleLogo={showGoogleLogoHeader}
                  >
                    Get Started
                  </CTAButton>

                </div>
              </>
        }



        </div>


      </header>
    </>
  )
}

export default RodrigoHeader 